import Virbac from "../../../../src/components/RenderImgs/virbacImgs";
import * as React from 'react';
export default {
  Virbac,
  React
};